import React from 'react';
import moment from 'moment';
import { Holiday } from 'src/components';

import { holidayColor } from '../../../../../constants/colors';
import { HolidaysMenuIcon } from '../../../../../Icons';
import {
  SectionBottomContainer,
  SectionContainer,
  SectionEmptyBlock,
  SectionHeader,
  SectionLabel,
  SectionWrapper,
} from '../common';

import { TimeListSection } from './components/TimeListSection';

enum HolidayTypes {
  Free = "Free days",
  Shortened = "Shortened days"
}

interface HolidaysSectionProps {
  holidays?: Array<Holiday>;
  lastUpdated?: string;
  onClick?: (typeOfHolidayId: string) => void;
}

export const HolidaysSection = ({
  holidays,
  onClick,
  lastUpdated,
}: HolidaysSectionProps) => {

  const freeDays = holidays?.filter((holiday) => !holiday.workHours);
  const shortenedDays = holidays?.filter((holiday) => holiday.workHours);

  const renderHolidaySection = (title: string, total: number, lastUpdated: string | undefined, typeOfHoliday: string) => {
    const normalizedLastUpdated = moment(lastUpdated || undefined).fromNow();

    return (
      <SectionContainer onClick={onClick ? () => {
        onClick?.(typeOfHoliday);
      }: undefined} color={holidayColor}>
        <>
          <SectionHeader
            label="Type"
          />
          <TimeListSection
            text={title}
          />
          <SectionBottomContainer
            labelLeft="Total"
            labelRight="Last Update"
            textLeft={`${total} days`}
            textRight={normalizedLastUpdated}
          />
        </>
      </SectionContainer>
    );
  }

  const renderShortenedDaysSection = () => {
    return shortenedDays?.length
      ? renderHolidaySection(HolidayTypes.Shortened, shortenedDays?.length, lastUpdated, "1")
      : null;
  }

  const renderFreeDaysSection = () => {
    return freeDays?.length
      ? renderHolidaySection(HolidayTypes.Free, freeDays?.length, lastUpdated, "0")
      : null;
  };

  return (
    <SectionWrapper>
      <>
        <SectionLabel
          Icon={HolidaysMenuIcon}
          label="Holidays"
        />
        {
          holidays?.length
            ? (
              <>
                {renderFreeDaysSection()}
                {renderShortenedDaysSection()}
              </>
            )
            : <SectionEmptyBlock/>
        }
      </>
    </SectionWrapper>
  );
};
